import makeStyles from '@ui/utils/makeStyles';

interface StyleProps {
  photosLength: number;
}

export default makeStyles<StyleProps>()((theme, { photosLength }) => ({
  root: {
    backgroundColor: 'black',
    minHeight: '100vh',
    overflow: 'hidden',
  },
  hero: {
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    minHeight: 300,
    [theme.breakpoints.up('lg')]: {
      minHeight: 450,
    },
  },
  smallHomePhotoContainer: {
    height: '100%',
    overflow: 'hidden',
    position: 'relative',
  },
  largeHomePhotoContainer: {
    display: 'flex',
    position: 'relative',
    height: 500,
    overflow: 'hidden',
    maxWidth: '1500px',
  },
  productMain: {
    display: 'flex',
  },
  productGallery: {
    flex: 890,
    display: 'flex',
  },
  productGalleryImage: {
    flex: 800,
    height: 700,
    overflow: 'hidden',
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    }
  },
  productGalleryList: {
    listStyleType: 'none',
    margin: 0,
    padding: 0,
    flex: 100,
    marginRight: theme.spacing(4),
  },
  productGalleryListItem: {
    width: 100,
    height: 100,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 10,
    cursor: 'pointer',
    transition: 'border 0.25s',
    border: '2px solid rgba(0, 0, 0, 0)',
    '&:hover': {
      border: '2px solid rgba(0, 0, 0, .5)',
    },
    '& img': {
      width: 90,
      height: 90,
      borderRadius: '50%',
      objectFit: 'cover',
    }
  },
  productGalleryListItemActive: {
    border: `2px solid ${theme.palette.common.black}`,
  },
  productInfo: {
    flex: 500,
    marginLeft: theme.spacing(6),
    padding: theme.spacing(4),
  },
  photoGrid: {
    display: 'grid',
    gridGap: 20,
    gridTemplateColumns: '1fr',
    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: '1fr 1fr',
    },
    [theme.breakpoints.up('lg')]: {
      gridTemplateColumns: '1fr 1fr 1fr 1fr',
    },
  },
  photoGridColumn: {
    height: 300,
    overflow: 'hidden',
    borderRadius: theme.shape.borderRadius,
    [theme.breakpoints.up('lg')]: {
      height: 450,
    }
  },
  photoGridPhoto: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  heroContent: {
    display: 'flex',
    flexWrap: 'wrap',
    maxWidth: 1500,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    [theme.breakpoints.up('lg')]: {
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      flexDirection: 'row',
      marginLeft: theme.spacing(2),
      marginTop: theme.spacing(4)
    },
  },
  aboutContainer: {
    position: 'relative',
    maxWidth: 1500,
    flexDirection: 'column',
    justifyContent: 'center',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
  },
  aboutRealtor: {
    order: 2,
    [theme.breakpoints.up('lg')]: {
      top: 0,
      order: 2,
      width: 530,
      marginRight: theme.spacing(3),
      position: 'relative',
    },
  },
  aboutInfo: {
    marginBottom: theme.spacing(6),
    [theme.breakpoints.up('lg')]: {
      width: 'calc(100% - 700px)',
      marginTop: 0,
      marginBottom: 0
    }
  },
  invisClickHomePhoto: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    zIndex: 1,
    cursor: 'default',
    [theme.breakpoints.down('md')]: {
      cursor: photosLength > 1 && 'pointer'
    }
  },
  openPhotos: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    '&:hover': {
      cursor: 'pointer',
    }
  },
  openPhotosOverlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.35)',
  },
  photoCount: {
    position: 'absolute',
    bottom: 50,
    left: 25,
    height: 20,
    display: 'block',
    color: '#FFFFFF',
    fontWeight: 600,
    fontFamily: theme.gh_vars.circular,
    fontSize: 14,
    [theme.breakpoints.up('lg')]: {
      display: photosLength < 2 ? 'none' : 'block',
      fontSize: 20,
      left: 50,
    }
  },
  interactionsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  interactionsPhotoCount: {
    display: 'none',
    [theme.breakpoints.up('lg')]: {
      height: 20,
      display: 'block',
      fontFamily: theme.gh_vars.circular,
      fontSize: 14,
      paddingRight: theme.spacing(2),
    },
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(1.5)
  },
  shopButtonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center'
  },
  vicinity: {
    fontSize: 16,
    fontFamily: theme.gh_vars.circular,
    color: '#666666',
  },
  photoBoxContainer: {
    display: 'grid',
    gridTemplateColumns: '4fr 4fr',
    gridTemplateRows: '2fr 1fr 1fr 1fr',
    gap: '4px 4px',
    maxWidth: 1500,
    height: 500,
    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: '1fr 1fr 1fr 1fr',
      gridTemplateRows: '1fr 1fr'
    }
  },
  homeInfoPaper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: 74,
    borderRadius: 0,
    [theme.breakpoints.up('md')]: {
      height: 96,
      padding: theme.spacing(3),
    }
  },
  homeInfoText1: {
    fontFamily: theme.gh_vars.mabryMono,
    fontSize: 13,
    lineHeight: 1.2,
    color: '#666666',
    marginBottom: theme.spacing(1.2)
  },
  homeInfoText2: {
    fontFamily: theme.gh_vars.circular,
    fontSize: 16,
    lineHeight: 1.25
  },
  roomNameText: {
    marginBottom: theme.spacing(1.5),
    '&:hover': {
      cursor: 'pointer',
    }
  },
  roomButtons: {
    color: '#000',
    height: 36,
  },
  roomItemsText: {
    color: '#fff',
    position: 'absolute',
    left: theme.spacing(6),
    top: theme.spacing(3),
    fontFamily: theme.gh_vars.circular,
  },
  dialogCloseButton: {
    color: '#fff',
    position: 'fixed',
    right: '3vw',
    top: theme.spacing(2)
  },
  dialogShareSaveContainer: {
    display: 'flex',
    flexDirection: 'row',
    position: 'fixed',
    right: '5vw',
    top: '12vh'
  },
  dialogArrowContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '90vw',
    position: 'fixed',
    bottom: '10vh',
    left: '50%',
    transform: 'translateX(-50%)'
  },
  selectIcon: {
    color: '#000',
    marginRight: theme.spacing(1)
  },
  homeIcons: {
    display: 'flex',
    flexDirection: 'row'
  },
  dialogPaper: {
    width: '90vw',
    maxWidth: '90vw !important',
    margin: '0 !important'
  },
  dialogProductCard: {
    height: '60vh'
  },
  likeButtonContainer: {
    backgroundColor: '#fff',
    borderRadius: theme.shape.borderRadius,
    paddingRight: theme.spacing(1)
  },
  sortButtonSmall: {
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(0.5, 1),
    border: '1px solid #DDDDDD',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between'
  },
  sortButtonLarge: {
    position: 'absolute',
    right: 0,
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(0.5, 1),
    border: '1px solid #DDDDDD',
    display: 'flex',
    justifyContent: 'space-between',
  },
  shareStartIcon: {
    marginBottom: theme.spacing(1),
  },
  seeAllLink: {
    cursor: 'pointer',
    textDecoration: 'underline',
    fontFamily: theme.gh_vars.mabryMono,
    color: theme.palette.common.black
  }
}));
